import { useMemo } from 'react';
import { useWindowDimensions } from 'react-native';
import { Redirect } from 'expo-router';
import { LayoutBreakpoints } from '@/constants/LayoutBreakpoints';

export default function Screen() {
  const { width } = useWindowDimensions();

  // Memoize the target to prevent re-renders from causing redirect loops
  const target = useMemo(() => {
    return width < LayoutBreakpoints.tablet
      ? '/(private)/(tabs)'
      : '/(private)/(sidebar)';
  }, [width]);

  return <Redirect href={target} />;
}
